module.exports = require('firebase/firestore');